// extracted by mini-css-extract-plugin
export default {"tooltip":"src-shared-tooltip__tooltip","fadeIn":"src-shared-tooltip__fadeIn","dark":"src-shared-tooltip__dark","light":"src-shared-tooltip__light"};